var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71591 0 0 6.75043 0 15.0771C0 22.6362 5.53977 28.8774 12.7582 29.9678V19.0732H9.04704V15.11H12.7582V12.4729C12.7582 8.10668 14.8745 6.18983 18.4848 6.18983C20.2139 6.18983 21.1282 6.31867 21.5611 6.37761V9.83712H19.0984C17.5657 9.83712 17.0305 11.2975 17.0305 12.9437V15.11H21.5223L20.9127 19.0732H17.0305V30C24.3518 29.0015 30 22.7095 30 15.0771C30 6.75043 23.2841 0 15 0Z",
    fill: "#4AFEBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ef060af3c9b2cfd4a2580979455fedc1.svg";
export { ForwardRef as ReactComponent };